/**
 * Converts a dataGroupId to a dataGroupIds Set
 */
export function convertDataGroupIdToSet(
  dataGroupId?: string,
  existingDataGroupIds?: Set<string | null>,
): Set<string | null> {
  if (existingDataGroupIds?.size) {
    return existingDataGroupIds;
  } else if (dataGroupId) {
    return new Set([dataGroupId]);
  }
  return new Set();
}

/**
 * Gets a single non-null data group ID from dataGroupIds, if it is the only member of the dataGroupIds set.
 */
export function getSingleDataGroupId(dataGroupIds?: Set<string | null>): string | undefined {
  if (!dataGroupIds) {
    return undefined;
  }
  if (dataGroupIds.size === 1) {
    const singleDataGroupId = dataGroupIds.values().next().value;
    if (singleDataGroupId !== null) {
      return singleDataGroupId;
    }
  }

  return undefined;
}
